import React, { useState, useEffect } from 'react';
import { FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon } from 'react-share';

const path = process.env.PUBLIC_URL

const Result = ({ score }) => {

  const [modal, setModal] = useState(false)

  function getName(input) {
    switch(input) {
      case '10/10':
        return '朝阳举报群众';
      case '9/10':
        return '审核大队政委';
      case '8/10':
      case '7/10':
        return '审核砖家叫兽';
      case '6/10':
      case '5/10':
        return '审核积极分子';
      default:
        return '审核办实习生';
    }
  }

  function getDesc(input) {
    switch(input) {
      case '10/10':
        return '大隐隐于市，莫非你就是审核机制的核心力量：热心观众？！';
      case '9/10':
        return '火眼金睛，心有红线，这个部门非你来领导不可了。';
      case '8/10':
      case '7/10':
        return '看得出来，你对敏感词自有一套心得，可以开班培训。';
      case '6/10':
      case '5/10':
        return '这年头考编沒那么容易，以你的敏感度想当审核员，马马虎虎，很难上岸。';
      default:
        return '这位外宾，对敏感词一无所知，感觉你本身可能也不太需要这个编制？';
    }
  }

  function getIndex(input) {
    let index = input.split("/")[0]
    return index
  }
  
  async function shareText(text, score) {
    const blob = await fetch(path + "/" + getIndex(score) + ".png").then(r=>r.blob())
    try {
      if (navigator.share) {
        // Share API is supported
        await navigator.share({
          files: [
            new File([blob], 'share.png', {
              type: blob.type,
            }),
          ],
          title: document.title,
          text: text,
          url: window.location.href
        });
        console.log('Text shared successfully');
      } else if (navigator.clipboard) {
        // Clipboard API is supported
        await navigator.clipboard.writeText(text + " " + window.location.href);
        setModal(true);
        console.log('Text copied to clipboard successfully');
      } else {
        // Fallback for unsupported browsers/platforms
        console.log("Sharing and clipboard not supported on this platform");
      }
    } catch (error) {
      console.log('Error:', error);
    }
  }

  useEffect(() => {
    let timeoutId = null;

    if (modal) {
      timeoutId = setTimeout(() => {
        setModal(false);
      }, 3000); // 5 seconds in milliseconds
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [modal]);
  
  return (
    <div className="result h-full w-full">
      <div className="result__container">
        <img src={`${path}/images/light.svg`} className="absolute w-[calc(100%_+_40px)] top-0 left-[-20px] translate-y-[-110%] max-w-none" />
        <img src={`${path}/images/flower.svg`} className="absolute w-[calc(100%_+_40px)] top-0 left-[50%] translate-y-[-50%] translate-x-[-50%] max-w-[500px]" />
        <img src={`${path}/images/bottom.svg`} className="bottom absolute h-[30%] md:h-[35%] w-[calc(100%_+_40px)] bottom-[-22px] left-[-20px] max-w-none border-[10px] border-skin object-cover" />
        <img src={`${path}/images/band.svg`} className="absolute w-[calc(100%_+_20px)] h-[50px] top-[calc(14px_+_70%)] md:top-[calc(14px_+_65%)] left-[-10px] max-w-none translate-y-[0%]" />
        <img src={`${path}/images/eye.svg`} className="absolute w-[100px] top-[calc(30px_+_70%)] md:top-[calc(30px_+_65%)] left-[50%] translate-x-[-50%]" />
        <h3 className="text-ink absolute w-full text-center text-2xl top-[18%] md:top-[21%] font-black">
          <span className="text-[19px] sm:text-[22px] md:text-[25px]">您答对了</span>
          <span className="text-[22px] sm:text-[26px] md:text-[32px] text-red font-black">{score}</span>
          <span className="block text-[19px] sm:text-[22px] md:text-[25px] mt-1 md:mt-2">特此授予称号</span>
          <div className="text-[24px] sm:text-[30px] md:text-[32px] score relative text-green inline-block mt-6 md:mt-7"><span>{getName(score)}</span></div><br/>
          <div className="resultDesc text-[14px] sm:text-[16px] mt-4 max-w-[288px] block leading-7 text-skin  p-2 text-center mx-auto">
            <span>{getDesc(score)}</span>
          </div>
          <button className="text-skin z-30 inline-block bg-ink border-[2px] px-2 py-0 text-[16px] rounded-lg" onClick={() => shareText("我在歪脑“你能当综艺歌词审核员吗”真题测试中，答对了" + score + ", 获得“" + getName(score) + "”称号。看看你能来当我领导吗？", score)}>
            <dialog id="modal" className={"rounded-lg bg-green py-2 px-3 absolute bottom-0 translate-y-[10px] text-ink " + (modal ? "block" : "hidden")}>
              <p>测试结果已复制！</p>
            </dialog>
            分享
            <svg className="w-5 h-5 text-skin inline mb-1 ml-1" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.803 5.33333C13.803 3.49238 15.3022 2 17.1515 2C19.0008 2 20.5 3.49238 20.5 5.33333C20.5 7.17428 19.0008 8.66667 17.1515 8.66667C16.2177 8.66667 15.3738 8.28596 14.7671 7.67347L10.1317 10.8295C10.1745 11.0425 10.197 11.2625 10.197 11.4872C10.197 11.9322 10.109 12.3576 9.94959 12.7464L15.0323 16.0858C15.6092 15.6161 16.3473 15.3333 17.1515 15.3333C19.0008 15.3333 20.5 16.8257 20.5 18.6667C20.5 20.5076 19.0008 22 17.1515 22C15.3022 22 13.803 20.5076 13.803 18.6667C13.803 18.1845 13.9062 17.7255 14.0917 17.3111L9.05007 13.9987C8.46196 14.5098 7.6916 14.8205 6.84848 14.8205C4.99917 14.8205 3.5 13.3281 3.5 11.4872C3.5 9.64623 4.99917 8.15385 6.84848 8.15385C7.9119 8.15385 8.85853 8.64725 9.47145 9.41518L13.9639 6.35642C13.8594 6.03359 13.803 5.6896 13.803 5.33333Z"/>
            </svg>
            
          </button>
        </h3>
        <img src={`${path}/images/chop.svg`} className="chop absolute w-[80px] top-[70%] md:top-[66%] left-[70%] z-10" />
      </div> 
    </div>
    
  );
};

export default Result;